export type StatusCopy = {
  pill: string;
  title: string;
  subtitle: string;
  etaLabel: (time: string) => string;
  progressMessages: string[];
  pillBg: string;
  pillBorder: string;
  pillText: string;
  pillDot: string;
};

export const COPY: Record<MaintenanceType, StatusCopy> = {
  planned: {
    pill: "Scheduled maintenance",
    title: "We'll be back shortly",
    subtitle:
      "Wieldy is undergoing planned maintenance. Your data is safe — we'll redirect you back automatically when we're done.",
    etaLabel: (time) => `Expected back by ${time}`,
    progressMessages: [
      "Rolling out the update",
      "Running migrations",
      "Warming up services",
      "Tidying up",
      "Almost there — you'll be redirected automatically",
    ],
    pillBg: "#FEF7E6",
    pillBorder: "#F4D98E",
    pillText: "#7A5A10",
    pillDot: "#C79019",
  },
  incident: {
    pill: "Investigating incident",
    title: "We're looking into this",
    subtitle:
      "We're investigating an issue with Wieldy and working on a fix. Your data is safe — we'll redirect you back automatically when it's resolved.",
    etaLabel: (time) => `Expected resolution by ${time}`,
    progressMessages: [
      "Engineering is on it",
      "Running diagnostics",
      "Narrowing down the root cause",
      "Rolling out a fix",
      "We'll get you back as soon as it's resolved — often sooner than the estimate above",
    ],
    pillBg: "#FEEDEC",
    pillBorder: "#F2B8B3",
    pillText: "#7A1F18",
    pillDot: "#C0362C",
  },
};
